import { VideoTrack, GridLayout } from '@livekit/components-react';
import styled from 'styled-components';
import { DisplayOrder } from './DisplayOrder';

export const VideoOverlay = styled.div`
  position: absolute;
  z-index: ${DisplayOrder.Overlay};
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.5) 0%,
    rgba(0, 0, 0, 0) 19.72%
  );
`;

export const StyledVideoTrack = styled(VideoTrack)`
  width: 100%;
  display: flex;
`;

export const StyledGridLayout = styled(GridLayout)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
`;
